import axios from 'axios';
import router from '@/_router';
import store from '@/_store';

/**
 * Configurazione interceptor Axios per gestire i 401 globalmente
 * Slogga l'utente automaticamente quando riceve un 401 che NON è
 * dovuto a "Email non verificata" o "Numero telefono non verificato"
 */
export function configureAxiosInterceptors() {
  axios.interceptors.response.use(
    (response) => {
      // Se la response è ok, la passiamo attraverso senza modifiche
      return response;
    },
    (error) => {
      // Gestiamo solo gli errori 401
      if (error.response && error.response.status === 401) {
        const errorMessage = error.response.data?.message;
        
        // Se il messaggio NON è uno di questi due specifici, slogga l'utente
        if (errorMessage !== "Email non verificata" && errorMessage !== "Numero telefono non verificato") {
          // Pulisce il localStorage
          localStorage.removeItem("user");
          localStorage.removeItem("token");
          localStorage.removeItem("company");
          
          // Cancella tutti gli alert attivi per evitare che compaiano dopo il logout
          store.commit('alert/clear');
          
          // Commit della mutazione logout nello store
          store.commit('utente/logout');
          
          // Redirect al login
          router.push('/login');
          
          // Restituiamo una Promise che non si risolve mai per "congelare" la catena
          // Questo impedisce sia l'esecuzione del .then() che del .catch()
          return new Promise(() => {});
        }
      }
      
      // Rigetta sempre l'errore per permettere alle catch locali di gestirlo
      return Promise.reject(error);
    }
  );
} 